class CustomProductGridSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.custom-product-grid__list');
    this.navWrapper = this.querySelector('.custom-product-grid__nav-wrapper');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    const desktopLayout = this.dataset.desktopLayout;
    const mobileLayout = this.dataset.mobileLayout;
    const needsCarousel = desktopLayout === 'carousel' || mobileLayout === 'carousel';

    if (!this.slider || !needsCarousel) return;

    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', this.scrollPrev.bind(this));
      this.nextButton.addEventListener('click', this.scrollNext.bind(this));
    }

    this.slider.addEventListener('scroll', this.updateButtons.bind(this));

    this.resizeObserver = new ResizeObserver(() => this.updateButtons());
    this.resizeObserver.observe(this.slider);

    this.updateButtons();
  }

  getScrollAmount() {
    const slide = this.slider.querySelector('.custom-product-grid__slide');
    if (slide) {
      const gap = parseInt(getComputedStyle(this.slider).gap) || 0;
      return slide.offsetWidth + gap;
    }
    return this.slider.offsetWidth * 0.5;
  }

  scrollPrev() {
    this.slider.scrollBy({
      left: -this.getScrollAmount(),
      behavior: 'smooth'
    });
  }

  scrollNext() {
    this.slider.scrollBy({
      left: this.getScrollAmount(),
      behavior: 'smooth'
    });
  }

  updateButtons() {
    const isScrollable = this.slider.scrollWidth > this.slider.clientWidth;

    if (this.navWrapper) {
      this.navWrapper.style.display = isScrollable ? '' : 'none';
    }

    if (!isScrollable || !this.prevButton || !this.nextButton) return;

    const scrollLeft = Math.round(this.slider.scrollLeft);
    const maxScroll = this.slider.scrollWidth - this.slider.offsetWidth;

    if (scrollLeft <= 5) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (scrollLeft >= maxScroll - 5) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }
}

customElements.define('custom-product-grid-slider', CustomProductGridSlider);
